import { ColumnsType } from 'antd/es/table'
import { ReferrersReportResponse } from 'api-client'

export const columns: ColumnsType<ReferrersReportResponse> = [
  {
    title: 'Referrer',
    key: 1,
    dataIndex: 'referrerName',
  },
  {
    title: 'Quantity',
    key: 2,
    dataIndex: 'count',
  },
]
